// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { InstantSearchResultListView, InstantSearchResult } from "../schema";
import { serialize_InstantSearchResultListView_internal, deserialize_InstantSearchResultListView_internal } from "./InstantSearchResultListView";

export function serialize_InstantSearchResult_internal(value: InstantSearchResult): unknown {
  return ((value: {
    ACTIONABLE: InstantSearchResultListView[] | null;
    CHANNEL: InstantSearchResultListView[] | null;
    CUSTOMPAGE: InstantSearchResultListView[] | null;
    SUMMARY: InstantSearchResultListView[] | null;
    VERIFAI: InstantSearchResultListView[] | null;
  }): unknown => {
    return {
      ACTIONABLE: ((value: InstantSearchResultListView[] | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.map((value: InstantSearchResultListView): unknown => {
          return serialize_InstantSearchResultListView_internal(value);
        });
      })(value["ACTIONABLE"]),
      CHANNEL: ((value: InstantSearchResultListView[] | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.map((value: InstantSearchResultListView): unknown => {
          return serialize_InstantSearchResultListView_internal(value);
        });
      })(value["CHANNEL"]),
      CUSTOMPAGE: ((value: InstantSearchResultListView[] | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.map((value: InstantSearchResultListView): unknown => {
          return serialize_InstantSearchResultListView_internal(value);
        });
      })(value["CUSTOMPAGE"]),
      SUMMARY: ((value: InstantSearchResultListView[] | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.map((value: InstantSearchResultListView): unknown => {
          return serialize_InstantSearchResultListView_internal(value);
        });
      })(value["SUMMARY"]),
      VERIFAI: ((value: InstantSearchResultListView[] | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.map((value: InstantSearchResultListView): unknown => {
          return serialize_InstantSearchResultListView_internal(value);
        });
      })(value["VERIFAI"]),
    };
  })(value);
}
export function serialize_InstantSearchResult(obj: InstantSearchResult): string {
  return renderJsonWithNumbersAsBigint(serialize_InstantSearchResult_internal(obj));
}
export function deserialize_InstantSearchResult_internal(value: unknown): ParserResult<InstantSearchResult> {
  return ((
    value: unknown,
  ): ParserResult<{
    ACTIONABLE: InstantSearchResultListView[] | null;
    CHANNEL: InstantSearchResultListView[] | null;
    CUSTOMPAGE: InstantSearchResultListView[] | null;
    SUMMARY: InstantSearchResultListView[] | null;
    VERIFAI: InstantSearchResultListView[] | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/InstantSearchResult]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResult]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "ACTIONABLE")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResult/ACTIONABLE]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'ACTIONABLE'.` };
    }
    const parsed_ACTIONABLE = ((): ParserResult<InstantSearchResultListView[] | null> => {
      return ((value: unknown): ParserResult<InstantSearchResultListView[] | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/InstantSearchResult/ACTIONABLE]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<InstantSearchResultListView> => {
          return deserialize_InstantSearchResultListView_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/InstantSearchResult/ACTIONABLE]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["ACTIONABLE"]);
    })();
    if (!parsed_ACTIONABLE.success) {
      return { success: false, reason: parsed_ACTIONABLE.reason };
    }
    if (!hasProp(value, "CHANNEL")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResult/CHANNEL]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'CHANNEL'.` };
    }
    const parsed_CHANNEL = ((): ParserResult<InstantSearchResultListView[] | null> => {
      return ((value: unknown): ParserResult<InstantSearchResultListView[] | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/InstantSearchResult/CHANNEL]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<InstantSearchResultListView> => {
          return deserialize_InstantSearchResultListView_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/InstantSearchResult/CHANNEL]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["CHANNEL"]);
    })();
    if (!parsed_CHANNEL.success) {
      return { success: false, reason: parsed_CHANNEL.reason };
    }
    if (!hasProp(value, "CUSTOMPAGE")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResult/CUSTOMPAGE]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'CUSTOMPAGE'.` };
    }
    const parsed_CUSTOMPAGE = ((): ParserResult<InstantSearchResultListView[] | null> => {
      return ((value: unknown): ParserResult<InstantSearchResultListView[] | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/InstantSearchResult/CUSTOMPAGE]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<InstantSearchResultListView> => {
          return deserialize_InstantSearchResultListView_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/InstantSearchResult/CUSTOMPAGE]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["CUSTOMPAGE"]);
    })();
    if (!parsed_CUSTOMPAGE.success) {
      return { success: false, reason: parsed_CUSTOMPAGE.reason };
    }
    if (!hasProp(value, "SUMMARY")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResult/SUMMARY]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'SUMMARY'.` };
    }
    const parsed_SUMMARY = ((): ParserResult<InstantSearchResultListView[] | null> => {
      return ((value: unknown): ParserResult<InstantSearchResultListView[] | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/InstantSearchResult/SUMMARY]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<InstantSearchResultListView> => {
          return deserialize_InstantSearchResultListView_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/InstantSearchResult/SUMMARY]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["SUMMARY"]);
    })();
    if (!parsed_SUMMARY.success) {
      return { success: false, reason: parsed_SUMMARY.reason };
    }
    if (!hasProp(value, "VERIFAI")) {
      return { success: false, reason: `[#/components/schemas/InstantSearchResult/VERIFAI]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'VERIFAI'.` };
    }
    const parsed_VERIFAI = ((): ParserResult<InstantSearchResultListView[] | null> => {
      return ((value: unknown): ParserResult<InstantSearchResultListView[] | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/InstantSearchResult/VERIFAI]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<InstantSearchResultListView> => {
          return deserialize_InstantSearchResultListView_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/InstantSearchResult/VERIFAI]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["VERIFAI"]);
    })();
    if (!parsed_VERIFAI.success) {
      return { success: false, reason: parsed_VERIFAI.reason };
    }
    return { success: true, value: { ACTIONABLE: parsed_ACTIONABLE.value, CHANNEL: parsed_CHANNEL.value, CUSTOMPAGE: parsed_CUSTOMPAGE.value, SUMMARY: parsed_SUMMARY.value, VERIFAI: parsed_VERIFAI.value } };
  })(value);
}
export function deserialize_InstantSearchResult(str: string): ParserResult<InstantSearchResult> {
  return deserialize_InstantSearchResult_internal(parseJsonWithNumbersAsBigint(str));
}
